import { c as _c } from "react/compiler-runtime";
import { Button, Popover, Stack, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { isValueCondition } from '@/types/advanceFilter';
import { TagsCondition } from './tagsCondition';
import type { TagsFilterProps } from './tagsFilter';
type TagsConditionSelectorProps = Omit<TagsFilterProps, 'allowChangingFilterMode' | 'onDoneClick' | 'panelTitle'>;
export const TagsConditionSelector = props => {
  const $ = _c(21);
  const anchorRef = useRef(null);
  const [popoverOpen, setPopoverOpen] = useState(props.popoverOpen || false);
  let t0;
  let t1;
  if ($[0] !== props.popoverOpen) {
    t0 = () => {
      if (props.popoverOpen !== undefined) {
        setPopoverOpen(props.popoverOpen);
      }
    };
    t1 = [props.popoverOpen];
    $[0] = props.popoverOpen;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let selectedTags;
  let t2;
  if ($[3] !== props.conditions || $[4] !== props.hideButton || $[5] !== props.property) {
    let t3;
    if ($[8] !== props.property) {
      t3 = x => isValueCondition(x) && x.property === props.property.name;
      $[8] = props.property;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    const condition = props.conditions.find(t3);
    selectedTags = isValueCondition(condition) && condition?.value || [];
    t2 = !props.hideButton && <Button ref={anchorRef} onClick={() => setPopoverOpen(true)} disableFocusRipple={true} size="small" className="px-0 py-[5px]"><Stack direction="row-reverse" gap="8px" className="pl-[12px] pr-[8px]"><i className="material-symbols-arrow-drop-down-rounded text-xl align-middle min-w-[22px] min-h-[22px] w-[22px] h-[22px]" />{selectedTags.length === 0 && <Typography variant="button" color="var(--mui-palette-text-disabled)" className="text-left font-medium">Select</Typography>}{selectedTags.length > 0 && <Typography variant="button" color="currentcolor" className="text-left font-medium">{selectedTags.join(", ")}</Typography>}</Stack></Button>;
    $[3] = props.conditions;
    $[4] = props.hideButton;
    $[5] = props.property;
    $[6] = selectedTags;
    $[7] = t2;
  } else {
    selectedTags = $[6];
    t2 = $[7];
  }
  const t3 = props.anchorRef || anchorRef;
  let t4;
  if ($[10] !== props) {
    t4 = () => {
      setPopoverOpen(false);
      props.onClose?.();
    };
    $[10] = props;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== popoverOpen || $[13] !== props || $[14] !== selectedTags || $[15] !== t3 || $[16] !== t4) {
    t5 = <TagsConditionPanelPopover {...props} anchorRef={t3} popoverOpen={popoverOpen} selectedTags={selectedTags} onChange={props.onChange} onClose={t4} />;
    $[12] = popoverOpen;
    $[13] = props;
    $[14] = selectedTags;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t2 || $[19] !== t5) {
    t6 = <>{t2}{t5}</>;
    $[18] = t2;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};
interface TagsConditionPanelPopoverProps extends TagsConditionSelectorProps {
  anchorRef: React.RefObject<HTMLElement | null>;
  popoverOpen: boolean;
  selectedTags: string[];
  onClose: () => void;
}
const TagsConditionPanelPopover = props => {
  const $ = _c(15);
  let t0;
  if ($[0] !== props) {
    t0 = () => props.onClose();
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.conditions) {
    t1 = [...props.conditions];
    $[2] = props.conditions;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props) {
    t2 = () => props.onClose();
    $[4] = props;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t3 = <Stack className="w-[308px]"><TagsCondition {...props} conditions={t1} onChange={props.onChange} onDoneClick={t2} /></Stack>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== props.anchorRef.current || $[11] !== props.popoverOpen || $[12] !== t0 || $[13] !== t3) {
    t4 = <Popover open={props.popoverOpen} anchorEl={props.anchorRef.current} onClose={t0}>{t3}</Popover>;
    $[10] = props.anchorRef.current;
    $[11] = props.popoverOpen;
    $[12] = t0;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};